import React, { Component } from 'react';
import config from "./../config.json";

class PersonelListCard extends Component {

  state = {
    values: this.props.values,
    isAllFields: this.props.isAllFields
  }

  componentDidMount() {
    if (this.state.values.kullanici.resim == null) {
      this.setState({ values: { ...this.state.values, kullanici: { ...this.state.values.kullanici, resim: config.blankPhoto } } });
    }
  }

  onClick = (event) => {
    this.props.parentCallback(this.state.values);
    event.preventDefault();
  }

  contextMenu = (e) => {
    e.preventDefault();
  }

  getImageSource = (resim) => {
    if (!resim) {
      return config.blankPhoto;
    }
    return String(resim).startsWith('data:image') ? resim : config.imageEndpoint + resim;
  }

  render() {
    return <tr>
      <td><img className="card-img-top card-img-bottom" alt="Personel Profil Fotoğrafı" src={this.getImageSource(this.state.values.kullanici['resim'])} onContextMenu={this.contextMenu} /></td>
      <td>{this.state.values.kullanici['ad']} {this.state.values.kullanici['soyad']}</td>
      {this.state.isAllFields ?
        <React.Fragment>
          <td>{this.state.values.kullanici['tcKimlikNo']}</td>
          <td>{this.state.values.kullanici['telefon']}</td>
          <td>{this.state.values.kullanici['dogumTarihi'] != null ? new Date(this.state.values.kullanici['dogumTarihi']).toLocaleDateString("tr-TR") : null}</td>
          <td>{this.state.values.kullanici['dogumYeri']}</td>
          <td>{this.state.values.kullanici['il']}</td>
          <td>{this.state.values.kullanici['ilce']}</td>
          <td>{this.state.values.kullanici['iseBaslamaTarihi'] != null ? new Date(this.state.values.kullanici['iseBaslamaTarihi']).toLocaleDateString("tr-TR") : null}</td>
          <td>{this.state.values.kullanici['istenAyrilmaTarihi'] != null ? new Date(this.state.values.kullanici['istenAyrilmaTarihi']).toLocaleDateString("tr-TR") : null}</td>
        </React.Fragment>
        : null}
      <td>{this.state.values.kullanici['gorevi']}</td>
      <td>{this.state.values.kullanici['departmanAdi']}</td>
      <td><button onClick={this.onClick}
        type="button"
        className="btn btn-outline-primary "
        data-bs-toggle="modal"
        data-bs-target="#modalCenter">Detay
      </button></td>
    </tr>;
  }

}

export default PersonelListCard;
